import { useSelector } from 'react-redux';

import { HELP_LINKS } from 'constants/helpCenterLinks.const';
import { selectCurrentSalonCountryCode } from 'selectors/currentSalon.selectors';

export const useHelpLinks = () => {
  const countryCode = useSelector(selectCurrentSalonCountryCode);
  return HELP_LINKS[countryCode] ?? HELP_LINKS.GB;
};
